// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import ToggleFilters from "@conklin/App/Widgets/ToggleFilters/ToggleFiltersComponent";
import { XNGAGE_CUSTOM_WIDGET } from "@conklin/XDL/constants";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

type Props = OwnProps;

export interface ToggleFiltersWidgetStyles {}

export const toggleFiltersWidgetStyles: ToggleFiltersWidgetStyles = {};

const styles = toggleFiltersWidgetStyles;

const ToggleFiltersWidget = ({ id, fields }: Props) => {
    return (
        <ToggleFilters expandByDefault={fields.expandByDefault} type="widget">
            <XngZone contentId={id} zoneName="filtersZone" hint="Zone for Filters" />
        </ToggleFilters>
    );
};

const widgetModule: WidgetModule = {
    component: ToggleFiltersWidget,
    definition: {
        displayName: "Toggle Filters",
        group: XNGAGE_CUSTOM_WIDGET,
        allowedContexts: [
            "OrderHistoryPage",
            "VmiOrderHistoryPage",
            "SavedOrderListPage",
            "OrderApprovalListPage",
            "InvoiceHistoryPage",
            "MyListsPage",
            "RfqMyQuotesPage",
        ],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
